import React, { Component } from 'react'
import { toast } from 'react-toastify'
import { connect } from 'react-redux'

import { Post } from 'utils/axios-token'
import Lang from 'Lang/General'

const HOC = ( WrappedComponent ) => {
  class WithHOC extends Component {
    state = {
      bulkData: {
        "raw": "",
        "type": "csv",
        "status": "ACTIVE",
        "center_id": 1,
        "recipient_groups": []
      },
      summary: {},
      openSummaryModal: false,
      files: [],
      loading: false
    }

    onChangeBulkHOC = ( key, val ) => this.setState({ [key]: val })

    load = param => this.setState({ loading: param })
    requestSuccess = success => toast.success( success )
    requestError = error => toast.error( error )

    createBulkRecipient = ( data ) => Post(
      `/api/v1/centers/${this.props.data.selectCenterReducer.selectedCenter.center.id}/funnel_recipient_csv`,
      {
        ...data,
        center_id: this.props.data.selectCenterReducer.selectedCenter.center.id
      },
      this.createBulkRecipientSuccess,
      this.createBulkRecipientError,
      this.load
    )
    createBulkRecipientSuccess = payload => {
      this.requestSuccess( Lang['UPLOAD_SUCCESS'][this.props.data.languageReducer.userSettings.admin_panel_language] )
      this.setState({
        summary: payload,
        openSummaryModal: true,
        bulkData: {
          "raw": "<base64>",
          "type": "csv",
          "status": "ACTIVE",
          "center_id": this.props.data.selectCenterReducer.selectedCenter.center.id,
          "recipient_groups": []
        },
        files: []
      })
    }
    createBulkRecipientError = error => {
      if( error.raw === 'raw is required'){
        this.requestError( Lang['UPLOAD_FILE'][this.props.data.languageReducer.userSettings.admin_panel_language] )
      } else if( error.type ) {
        this.requestError( error.type )
      } else {
        this.requestError( error )
      }
    }

    render = () => {
      return(
        <>
          <WrappedComponent
            {...this.props}
            bulkData={ this.state.bulkData }
            onChangeBulkHOC={ this.onChangeBulkHOC }
            summary={ this.state.summary }
            createBulkRecipient={ this.createBulkRecipient }
            openSummaryModal={ this.state.openSummaryModal }
            onLoadBulkUpload={ this.state.loading }
            files={ this.state.files }/>
        </>
      )
    }
  }
  const mapStateToProps = state => ({ data: state })
  return connect( mapStateToProps )( WithHOC )
}
export default HOC
